module.exports = __webpack_public_path__ + "img/9791160941050.719a1df0.jpg";